import {createContext} from 'react'

const removeItem = (state, uuid) => {
  const items = {...state.items}
  delete items[uuid]
  return {...state, items: items}
}

export const cartReducer = (state, action) => {
  const result = handleAction(state, action)
  localStorage.setItem('cart', JSON.stringify(result.items))
  return result
}

const handleAction = (state, {type, payload}) => {
  switch (type) {
    case 'add':
      return {...state, items: {...state.items, [payload.item.uuid]: {...payload.item}}}
    case 'quantity':
      if (payload.quantity === 0) return removeItem(state, payload)
      else {
        const newState = {...state}
        newState.items[payload.uuid].quantity = payload.quantity
        return newState
      }
    case 'increment':
      const newState = {...state}
      newState.items[payload.uuid].quantity += payload.amount
      return newState
    case 'decrement':
      if (state.items[payload.uuid].quantity > payload.amount) {
        const newState = {...state}
        newState.items[payload.uuid].quantity -= payload.amount
        return newState
      } else {
        return removeItem(state, payload.uuid)
      }
    case 'remove':
      return removeItem(state, payload)
    case 'reset':
      return defaultCart
    case 'setVoucher':
      return {...state, discounts: [payload]}
    case 'usePoints':
      return {...state, points: payload}
    default:
      return state
  }
}

export const defaultCart = {
  items: {},
  discounts: [],
  points: 0,
}

export default createContext({
  cart: defaultCart,
  cartDispatch: null,
  cartVisible: false,
  setCartVisible: () => {},
})
